import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { object, func } from 'prop-types';
import Card from '../Card/Card';
import { createMarkup } from '../../utils/utils';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const propTypes = {
  page: object.isRequired,
  reload: func.isRequired,
};
const defaultProps = {
  page: {},
};

const FaqRecommendation = ({ page, reload, loading }) => (
  <Card className={loading ? 'faq-recommendations card-loading' : 'faq-recommendations'}>
    <Card.Body>
      <div className="faq-recommendations-title-wrap">
        <p className="faq-recommendations-title">
          <FormattedMessage id="faq.recommendation" defaultMessage="Recommendation" />
        </p>
        <Button
          onClick={reload}
          color="secondary"
          size="sm"
          className="faq-recommendations-btn-refresh"
        >
          <SVG
            className="faq-tree-list-icon"
            src={`${STATIC_PATH}/img/action-icons/refresh_icon.svg`}
            height="24"
            width="24"
            cacheRequests
          />
        </Button>
      </div>

      <h4>{page.title}</h4>

      <div dangerouslySetInnerHTML={createMarkup(page.preview)} />

      <Link to={`/${page.path}`}>
        <FormattedMessage id="faq.read_all" defaultMessage="Read more" />
      </Link>
    </Card.Body>
  </Card>
);

FaqRecommendation.propTypes = propTypes;
FaqRecommendation.defaultProps = defaultProps;

export default FaqRecommendation;
